export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_13.b0ab4d1c.jpg";